import { useQuery } from '@tanstack/react-query'
import { useCallback } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { liveGuestService } from '../../../services/lives/guests'
import { useGlobalStore } from '../../../store/global-store'

export const LIVE_GUESTS_QUERY_KEY = 'getLiveGuests'

export const useGetLiveGuests = () => {
  const liveId = useGlobalStore(useShallow((state) => state.liveId))

  const { data, refetch } = useQuery({
    queryKey: [LIVE_GUESTS_QUERY_KEY, { liveId: Number(liveId) }],
    staleTime: Infinity,
    enabled: Boolean(liveId),
    queryFn: () => liveGuestService.get({ liveId: Number(liveId) }),
  })

  const checkLiveGuest = useCallback(
    (userId: number) => {
      return data?.data?.find((item) => {
        return Number(item?.userId) === Number(userId)
      })
    },
    [data],
  )

  return {
    guests: data?.data ?? [],
    refetch,
    checkLiveGuest,
  }
}
